module.exports = __webpack_public_path__ + "assets/img/email-b4ccd928.png";